import ModuleSection from '../ModuleSection';
import Quiz from './Quiz';
import { resolveSectionProps, useSectionText } from '../../lib/useSectionText';
import './QuizModule.css';

const DEFAULTS = {
  number: '02',
  kicker: 'Where Candidates Land On',
  title: (
    <>
      Your <em>Views</em>
    </>
  ),
  intro: (
    <>
      <p>
        We sent every Maltese candidate the same 21 questions about how they
        view politics and the world around us. Answer them yourself and see
        which of them genuinely think like you — ranked, mapped, and shown
        answer-by-answer.
      </p>
      <p>Watch this space.</p>
    </>
  ),
};

export default function QuizModule() {
  const sectionText = useSectionText('quiz');
  return (
    <ModuleSection {...resolveSectionProps(DEFAULTS, sectionText)} id="quiz">
      <div className="quiz-shell">
        <Quiz />
      </div>
    </ModuleSection>
  );
}
